const moment = window.moment;

const fetchFileMetadata = nodeRef =>
  fetch(`${window.appContext}/proxy/alfresco/api/node/${nodeRef.replace(':/', '')}/metadata?${moment().unix()}`, {
    credentials: 'same-origin',
  })
    .then(response => {
      if (response.status !== 200) {
        throw new Error(response);
      }

      return response.json();
    })
    .catch(reason => {
      throw reason;
    });

export default fetchFileMetadata;
